import { ref, onMounted, onBeforeUnmount, nextTick } from "vue";

export function useMatchTriggerWidth() {
  const triggerEl = ref(null);
  const panelStyle = ref({});

  const measure = () => {
    const el = triggerEl.value?.$el || triggerEl.value;
    if (el) {
      panelStyle.value = { width: `${el.offsetWidth}px` };
    }
  };

  onMounted(async () => {
    await nextTick();
    measure();
    window.addEventListener("resize", measure);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", measure);
  });

  return { triggerEl, panelStyle, measure };
}
